import React from 'react';
import { Button, Col, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import CampaignGroupFilterHolder from '../../styles/campaignGroupFilterStyle';
import { getDomain } from '../../../../../services/utils';

const { Text } = Typography;

const ScreensGroupFilterComponent = props => {
  const domain = getDomain(window.location.hostname);

  const { t } = useTranslation();
  const {
    managerDisplayFilter,
    managerDisplaySelector,
    setManagerDisplaySelector,
    setManagerDisplayFilter,
    disabledManagerDisplayFilter,
    disableManagerDisplayFilter,
    customContents,
    cart,
    realAmount,
    updateCustomContents
  } = props;

  const arrFilter = [
    {
      name: 'aspect',
      label: 'Aspect ratio'
    },
    {
      name: 'dimensions',
      label: 'General dimensions'
    },
    {
      name: 'resolution',
      label: 'Resolution'
    },
    {
      name: 'screen',
      label: 'Type'
    },
    {
      name: 'subtype',
      label: 'Subtype'
    },
    {
      name: 'none',
      label: 'None'
    }
  ];

  const onClick = filter => {
    if (filter.name === managerDisplayFilter) return;
    if (filter.name === 'none') setManagerDisplaySelector('');
    setManagerDisplayFilter(filter.name);
    disableManagerDisplayFilter(true);
  };

  // Only for pending campaign
  const redistributeImpressionsEquitably = () => {
    const listCostDisplay = cart.reduce((acc, display) => {
      acc[display.id] = display.smart_campaign_cpm / 1000;
      return acc;
    }, {});
    const totalCostPerImpression = customContents.reduce((acc, customContent) => {
      return acc + (listCostDisplay[customContent.displayId] || 0);
    }, 0);
    let totalImpressions = Math.floor(realAmount / totalCostPerImpression);
    let assignedBudget = 0;
    let customContentsAux = customContents.map((customContent, index) => {
      assignedBudget = assignedBudget + totalImpressions;
      return { ...customContent, promised_shows: totalImpressions };
    });
    let remainingBudget = realAmount - assignedBudget;
    for (let i = 0; i < customContentsAux.length && remainingBudget > 0; i++) {
      const extraCost = customContentsAux[i].smart_campaign_cpm;
      if (remainingBudget >= extraCost) {
        customContentsAux[i].promised_shows += 1;
        remainingBudget = remainingBudget - extraCost;
      }
    }
    updateCustomContents(customContentsAux);
  };

  return (
    <CampaignGroupFilterHolder>
      <p className="stepSectionTitle">{t('Organize screens')}</p>
      <Row type="flex" align="middle" justify="space-between">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="groupFilter">
          <div className="contentGroupFilter">
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
              {arrFilter.map(filter => (
                <Button
                  key={filter.name}
                  className="groupFilterButton"
                  type={managerDisplayFilter === filter.name ? 'primary' : ''}
                  disabled={disabledManagerDisplayFilter}
                  onClick={() => onClick(filter)}
                >
                  {t(filter.label)}
                </Button>
              ))}
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="contentGroupFilter">
            <div className="distributedBy">
              <Text>{t('Distributed by')}:</Text>
              <Select
                value={managerDisplaySelector}
                onChange={setManagerDisplaySelector}
                className="distributedBySelect"
                disabled={managerDisplayFilter === 'none'}
              >
                <Select.Option key={'nothing'} value={''}>
                  {t('None')}
                </Select.Option>
                <Select.Option key={'country'} value={'country'}>
                  {t('Country')}
                </Select.Option>
                <Select.Option key={'administrative_area_level_1'} value={'administrative_area_level_1'}>
                  {t('Province/State')}
                </Select.Option>
                <Select.Option key={'administrative_area_level_2'} value={'administrative_area_level_2'}>
                  {t('City')}
                </Select.Option>
                <Select.Option key={'company'} value={'company'}>
                  {t('Media owners')}
                </Select.Option>
              </Select>
            </div>
          </div>
        </Col>
      </Row>
    </CampaignGroupFilterHolder>
  );
};

export default ScreensGroupFilterComponent;
